import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from "@angular/core";
import {
  ISvgSpriteRegisterService,
  SvgSpriteRegisterService,
} from "@app/core/services/svg-sprite-register.service";
import { SvgIconFallbackComponent } from "./components/svg-icon-fallback/svg-icon-fallback.component";
import { SvgIcon } from "./svg-icons.model";

@Component({
  selector: "app-svg-icon",
  templateUrl: "./svg-icon.component.html",
  styles: `
    :host {
      display: flex;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SvgIconFallbackComponent],
})
export class SvgIconComponent {
  @Input({ required: true }) icon: SvgIcon | string = "";
  @Input() fill = "";
  @Input() width: string | null = null;
  @Input() height: string | null = null;

  readonly svgSpriteRegisterService: ISvgSpriteRegisterService = inject(
    SvgSpriteRegisterService,
  );

  get iconExists() {
    return this.svgSpriteRegisterService.isExist(this.icon);
  }

  get spriteLoaded() {
    return this.svgSpriteRegisterService.loaded();
  }
}
